<template>
  <div class="gameplan">
    <ContentHeader path-set-type="append" :gameplan-nav="false" />
    <div class="content-wrapper" v-loading="loading">
      <!-- 新建活动 -->
      <div class="activity_new">
        <div class="normal_title">{{this.themeId?'修改活动主题':'新建活动主题'}}</div>
        <div class="activity-new-card is-hover-shadow">
          <el-form :inline="true"  label-position="right" :model="themeBasic" label-width="140px" :rules="editRules" ref="themeInfoRef">
            <el-form-item label="选择PR：" prop="prInfo">
              <div class="sp-el-input">
                <el-input class="item" v-model="themeBasic.prInfo" placeholder="请选择PR" readonly />
                <el-button type="redFont" @click="showSelectPRDialog">选择</el-button>
              </div>
            </el-form-item>
            <el-form-item label="品牌-子品牌：">
              {{ getBrandInfo }}
            </el-form-item>
            <el-form-item label="活动名称：" prop="themeName">
              <el-input class="item" v-model="themeBasic.themeName" placeholder="输入活动名称" />
            </el-form-item>
            <el-form-item label="活动主题级别：">
              {{ getLevel }}
            </el-form-item>
            <el-form-item label="活动时间：" prop="themeTime">
              <el-date-picker v-model="themeBasic.themeTime" :clearable="false" value-format="timestamp" type="daterange" range-separator="至" start-placeholder="开始日期"
                end-placeholder="结束日期" >
              </el-date-picker>
            </el-form-item>
            <el-form-item label="配置执行数据："  required>
              <el-button @click="$refs['ConfigureExecutionData'].handleOpen()" type="redFont">配置执行数据</el-button>
            </el-form-item>
            <!-- <el-form-item label="选择SKU：" prop="prNumber">
              <div class="sp-el-input">
                <el-input class="item" v-model="skuName" placeholder="请选择SKU" readonly />
                <el-button type="redFont" @click="showSelectSkuDialog">选择</el-button>
              </div>
            </el-form-item> -->
            <el-form-item label="活动执行手册：" >
              <div>
                <FileUpload
                  ref="manualFileIdRef"
                  :upload-param="{ filePath: 'temp' }"
                  :save-item = "manualFile"
                  show-type="text"
                  @uploaded="getManualFileId"
                  @removed="clearManualFileId" >
                  <el-button  type="redFont">上传执行手册</el-button>
                </FileUpload>
              </div>
            </el-form-item>
            <!-- <div class="upload_section">
              <div class="upload_item">
                <div class="upload_item_title"><span style="color:white"> </span> &ensp; 活动执行手册</div>
                <FileUpload
                  ref="manualFileIdRef"
                  :upload-param="{ filePath: 'temp' }"
                  :save-item = "manualFile"
                  show-type="text"
                  @uploaded="getManualFileId"
                  @removed="clearManualFileId" >
                  <div class="upload_item_btn">上传执行手册</div>
                </FileUpload>
              </div>
              <div class="upload_item">
                <div class="upload_item_title"><span style="color:white"> </span> &ensp; 活动执行数据收集模板</div>
                <FileUpload
                  ref="execTemplateIdRef"
                  :upload-param="{ filePath: 'temp' }"
                  :save-item = "execTemplate"
                  show-type="text"
                  @uploaded="getExecTemplateId"
                  @removed="clearExecTemplateId" >
                  <div class="upload_item_btn">上传模板</div>
                </FileUpload>
              </div>
            </div> -->
          </el-form>
        </div>
      </div>

      <div class="btn_section">
        <div class="normal_btn btn_bg_white" @click="handleCancel">取消</div>
        <div class="normal_btn btn_bg_red" @click="handleSubmit">提交</div>
      </div>
    </div>

    <configureSelectePRDialog ref="selectPRDialog" @handleSelectPR="handleSelectPR"/>
    <configureSelecteSkuDialog :skuScope="themeBasic.skuScope" ref="selectSkuDialog" @handleSelectSku="handleSelectSku" :prNumber="themeBasic.prNumber" />

    <el-dialog
      title="提示"
      :visible.sync="showConfirmDialog"
      width="30%" >
      <span>是否确认提交当前数据？</span>
      <span slot="footer" class="dialog-footer">
        <el-button type="redFont" @click="showConfirmDialog = false">取 消</el-button>
        <el-button type="danger" :loading="submitting" @click="getGameplanThemeSubmit()">确 定</el-button>
      </span>
    </el-dialog>
    <ConfigureExecutionData ref="ConfigureExecutionData" @on-submit="handleExecutionData" :execDataConfigedList="execDataConfigList"></ConfigureExecutionData>
  </div>
</template>
<script>
import FileUpload from './components/file-upload'
import gameplanApi from "@/api/gameplan";
import ContentHeader from "@/components/content-header";
import { mapGetters,mapState } from 'vuex'
import configureSelectePRDialog from './components/configure-select-PR-dialog'
import ConfigureExecutionData from './components/configure-execution-data'
import configureSelecteSkuDialog from './components/configure-select-sku-dialog'
export default {
  components: {
    ContentHeader,
    FileUpload,
    configureSelectePRDialog,
    configureSelecteSkuDialog,
    ConfigureExecutionData
  },
  data() {
    var validateThemeTime = (rule, value, callback) => {
      if (!value||value.length===0) {
        return callback(new Error('请选择活动时间'));
      }else {
        return callback()
      }
      // if(value[0]<now){
      //   return callback(new Error('执行时间不可早于当前时间'));
      // }
    };
    return {
      prInfo:'',
      execDataConfigList:[],
      loading:false,
      employeeLevel: '',
      prNumber:'',
      themeBasic: {
        themeName:'',
        prNumber:'',
        prName:'',
        manualFileId:'',
        execTemplateId:'',
        themeTime:[],
        skuScope:'',
        prId:'',
        prInfo:''
      },
      skuName:'',
      editRules: {
        themeName: [
          { required: true, message: "请输入活动名称", trigger: "blur" },
        ],
        themeTime:[
          {validator: validateThemeTime, trigger: 'blur'},
          { required: true, message: "请选择活动时间", trigger: "blur" },
        ],
        prInfo: [
          { required: true, message: "请选择PR", trigger: "change" },
        ],
        skuScope: [
          { required: true, message: "请选择SKU", trigger: "change" },
        ],
      },
      themeId:'',
      showConfirmDialog:false,
      errorList:[],
      manualFile: [],
      execTemplate:[],
      prInfoList:[],
      gpPrDTOList:[],
      initPrNumberList:[],
      submitting:false
    };
  },
  computed: {
    // ...mapState({
    //   fileUploadTarget: state => state.app.fileUploadTarget,
    // }),
    ...mapGetters(['userInfo']),
    getLevel(){
      if(this.employeeLevel>=90) return 'HQ'
      else if(this.employeeLevel>=60&&this.employeeLevel<90) return 'BU'
      else if(this.employeeLevel>=45&&this.employeeLevel<60) return 'region'
      return ''
    },
    getBrandInfo(){
      let brandInfo = []
      this.prInfoList.forEach(item=>{
        let data = ''
        if(item.brandName&&item.subBrandName)  data = item.brandName+'-'+item.subBrandName
        else data = item.brandName||item.subBrandName
        if(brandInfo.indexOf(data)===-1) { brandInfo.push(data) }
      })
      return brandInfo.join('、')
      // if(this.prNumber){
      //   if(this.prInfo.brandName&&this.prInfo.subBrandName){
      //     return this.prInfo.brandName+'-'+this.prInfo.subBrandName
      //   }else return this.prInfo.brandName||this.prInfo.subBrandName
      // }else return '暂无'
      //return '暂无'
    },
  },
  mounted() {
    this.employeeLevel = this.userInfo.employeeLevel
    this.themeId = this.$route.query.themeId || ''
    if(this.themeId) {
      this.getGameplanThemeBasicInfo()
      this.getExecDataConfig()
    }
  },
  methods: {
    showSelectPRDialog(){
      this.$refs.selectPRDialog.show(this.prInfoList,this.initPrNumberList)
    },
    showSelectSkuDialog(){
      this.$refs.selectSkuDialog.show()
    },
    handleSelectPR(prInfoList){
      const prInfo = []
      this.gpPrDTOList = []
      this.prInfoList = prInfoList.map(item=>{
        prInfo.push(item.prNumber+'-'+item.prName)
        this.gpPrDTOList.push({prNumber:item.prNumber})
        return item
      })
      this.themeBasic.prInfo = prInfo.join('、')
    },
    handleSelectSku(data){
      this.themeBasic.skuScope = data.skuScope.join(',')
      this.skuName = data.skuName.join(',')
    },
    handleCancel(){
      this.$router.go(-1)
    },
    handleSubmit(){
      this.$refs.themeInfoRef.validate(valid=>{
        if(valid){
          this.showConfirmDialog = true
        }
      })
    },
    async getGameplanThemeSubmit() {
      this.submitting = true
      const gpThemeExecFieldDTO = {
        execDataConfigList:this.execDataConfigList
      }
      const themeBasic = {
            prNumber:this.themeBasic.prNumber,
            themeName:this.themeBasic.themeName,
            themeStartTime:this.themeBasic.themeTime[0],
            themeEndTime:this.themeBasic.themeTime[1],
            themeId:this.themeId,
            skuScope:this.themeBasic.skuScope,
            manualFileId:this.themeBasic.manualFileId,
            gpPrDTOList:this.gpPrDTOList
      }
      const params = {themeBasic,gpThemeExecFieldDTO}
      const {data}  = await gameplanApi.getGameplanThemeSubmitThemeInfo(params);
      if (data.resultCode === "0") {
        this.$message.success("提交成功！")
        this.$router.go(-1)
      }
      this.showConfirmDialog = false
      this.submitting = false
    },
    async getExecDataConfig() {
      const params = {themeId:this.themeId}
      const {data}  = await gameplanApi.getExecDataConfig(params);
      if (data.resultCode === "0") {
        this.execDataConfigList = data.resultData.execDataConfigList || []
      }
    },
    async getGameplanThemeBasicInfo() {
      this.loading = true
      const params = {
        themeId : this.themeId
      }
      const {data}  = await gameplanApi.getGameplanThemeBasicInfo(params);
      if (data.resultCode === "0") {
        this.themeBasic.prNumber = data.resultData.themeInfo?.prNumber || ''
        this.themeBasic.prName = data.resultData.themeInfo?.prName || ''
        this.themeBasic.themeName = data.resultData.themeInfo?.themeName || ''
        this.themeBasic.skuScope = data.resultData.themeInfo?.skuScope || ''
        const skuDTOList =  data.resultData.themeInfo?.skuDTOList || []
        this.skuName = skuDTOList.reduce((pre,item)=>{
          return pre+item.skuName
        },'')
        this.prNumber = data.resultData.themeInfo?.prNumber || ''
        this.prInfoList = data.resultData.themeInfo?.gpPrDTOList || []
        const prInfo = []
        this.prInfoList.map(item=>{
          prInfo.push(item.prNumber+'-'+item.prName)
          this.gpPrDTOList.push({prNumber:item.prNumber})
          this.initPrNumberList.push(item.prNumber)
        })
        this.themeBasic.prInfo = prInfo.join("、")
        // this.prInfo.brandName = data.resultData.themeInfo?.brandName || ''
        // this.prInfo.subBrandName = data.resultData.themeInfo?.subBrandName || ''
        // this.prInfo.prNumber = data.resultData.themeInfo?.prNumber || ''
        this.themeBasic.themeTime.splice(0,0,data.resultData.themeInfo.themeStartTime,data.resultData.themeInfo.themeEndTime)
        let manualFileInfo = {
          name:data.resultData.themeInfo?.manualFileName,
          url:data.resultData.themeInfo?.manualFileUri,
          fileId:data.resultData.themeInfo?.manualFileId
        }
        this.themeBasic.manualFileId = data.resultData.themeInfo?.manualFileId|| ''
        if(data.resultData.themeInfo.manualFileId) this.manualFile.splice(0,0,manualFileInfo)
      }
      this.loading = false
    },

    // 上传文件
    getManualFileId (file) {
      this.themeBasic.manualFileId = file.fileId
    },
    getExecTemplateId (file) {
      this.themeBasic.execTemplateId = file.fileId
    },
    // 删除文件
    clearManualFileId (file) {
      this.themeBasic.manualFileId = ''
      this.errorList = []
    },
    clearExecTemplateId (file) {
      this.themeBasic.execTemplateId = ''
      this.errorList = []
    },
    handleExecutionData(executionData){
      this.execDataConfigList = executionData
    }
  },
};
</script>
<style lang="scss" scoped>
::v-deep .activity_new .el-form-item {
  min-width: 48%;
  margin-bottom: 24px;
  .el-form-item__label {
    width: 160px !important;
    color: black;
    font-weight: 600;
  }
  .el-form-item__content{
    width: 300px;
  }
}

::v-deep .el-date-editor.el-input__inner{
  width: 300px;
}
.sp-el-input .el-input{
  width: 218px;
  margin-right: 10px;
}

.content-wrapper {
  .activity_new {
    position: relative;
    margin-top: -50px;

    .activity-new-card {
      padding: 20px 10px 20px 0px;
      background-color: #ffffff;
      color: #101010;
      border-radius: 10px;
      font-size: 16px;
      //font-weight: bold;
      text-align: left;
      display: flex;
      justify-content: flex-start;
    }
  }
}

.upload_section {
  margin: 10px 0 0 8px;
  font-size: 12px;
}
.upload_item {
  display: flex;
}
.upload_item_title {
  width: 160px;
  font-size: 14px;
  font-weight: 600;
  padding: 20px 0px;
  text-align: right;
}
.upload_item_btn {
  cursor: pointer;
  margin: 13px 0 0 20px;
  height: 30px;
  line-height: 30px;
  width: 100px;
  border-radius: 5px;
  text-align: center;
  vertical-align: middle;
  color: white;
  background-color: rgb(204, 0, 0);
}

.btn_section{
  width: 100%;
  display: flex;
  justify-content: center;
  font-size: 15px;
  text-align: center;
  margin-top: 60px;
  .normal_btn{
    width: 100px;
    padding: 10px 0;
    border-radius: 5px;
    cursor: pointer;
  }
  .btn_bg_white{
    border: 1px solid rgb(204, 0, 0);
    color: rgb(204, 0, 0);
    margin-right: 100px;
  }
  .btn_bg_red{
    color: white;
    background-color: rgb(204, 0, 0);
    border: 1px solid rgb(204, 0, 0);
  }
}
</style>
